import { UiToggleProps } from "./types";
import styles from "./ui-toggle.module.css";

const UiToggle = ({ checked, onChange }: UiToggleProps) => {
  return (
    <input
      type='checkbox'
      checked={checked}
      onChange={() => onChange(!checked)}
      className={styles.checkbox} />);


};

export default UiToggle;